module.exports = __webpack_public_path__ + "src/routes/register/LOGO.svg?d7dd6657";


//////////////////
// WEBPACK FOOTER
// ./src/routes/register/LOGO.svg
// module id = 2855
// module chunks = 1